import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .raymond-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    h2 {
      padding-bottom: calc(20rem / var(--default-rem-px-count));
    }

    img {
      max-width: 100%;
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
      padding-bottom: calc(30rem / var(--default-rem-px-count));
    }

    .drivers {
      grid-column: 2 / 8;
      grid-row: 3;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: var(--between-row-padding-lg);
    }

    .image {
      width: 100%;
      aspect-ratio: 3 / 2;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /* Card titles pin the title-small scale (16/20 -> 18/24) so the
       full-size h3 default doesn't inflate them. */
    .image-title {
      padding-top: calc(16rem / var(--default-rem-px-count));
      font-size: var(--fs-title-small);
      line-height: var(--lh-title-small);
      letter-spacing: var(--ls-title-small);
    }

    .image-description {
      padding-top: calc(10rem / var(--default-rem-px-count));
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
    }

    @media (min-width: 600px) {
      .header {
        padding-bottom: calc(60rem / var(--default-rem-px-count));
      }

      .drivers {
        grid-column: 2 / 14;
        grid-template-columns: repeat(12, minmax(0, 1fr));
        gap: var(--between-row-padding-lg) var(--between-column-padding);
      }

      /* Three cards per row, edges on the page grid lines. */
      .driver-wrapper {
        grid-column: span 4;
      }

      .image-title {
        padding-top: calc(20rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      /* Four per row on desktop. */
      .driver-wrapper {
        grid-column: span 3;
      }
    }
  `,
];
